import React from "react";
import appPath from "../../utils/appPath";
import { SCREENS } from "common/constants/Constants";

const PageNotFound = () => (
    <div className="page-not-found">
        <h1 className="page-not-found__title">404 - Page Not Found</h1>
        <a className="page-not-found__link" href={ appPath(SCREENS.SIGNUP) }>Return to Sign In page</a>
    </div>
);

export default PageNotFound;
